module.exports = __webpack_public_path__ + "img/code.d33ce173.svg";